import axios from "axios";
import {DateType} from "@date-io/type";

// interface for param apply dashboard table
export interface IGetBookingsDisambiguationJimpiListParams {
    start?: number,
    limit?: number
}

export interface bookingsDisambiguationJimpi {
    id: number,
    rentwayNumber: string,
    dossierNumber: string,
    dropoffLocation: string,
    pickupLocation: string,
    customerNr: string,
    customerCode: string,
    dropoffDate:  string,
    pickupDate:  string,
    cargroupModel: string,
    driverSurname: string,
    driverName: string,
    idBooking: string;
}

export const getBookingDisambiguationJimpi = async (params: IGetBookingsDisambiguationJimpiListParams): Promise<bookingsDisambiguationJimpi[]> => {
    const response = await axios.get('/booking/import/disambiguationBookings', {params: {start: params.start, limit: params.limit}});
    return response.data;
};

export default getBookingDisambiguationJimpi;
